export const AnalisisColumnsValuesKeys = {
    RELATIVE: 'relative',
    ABSOLUTE: 'absolute',
    MIN: 'min',
    MAX: 'max',
};
//# sourceMappingURL=AnalisisColumnsValuesKeys.js.map